const digest = '55d33ba99847646766b87ac59c647364f13bd146e14e09414d43cc6d0f3223bf';
const css = `._dontLiveWithoutLogo_x4ebb_1{width:381px}._blueBoxLogo_x4ebb_5{width:140px}._collapsibleTextBody_x4ebb_9 a{text-decoration:underline}@media (max-width:767px){._dontLiveWithoutLogo_x4ebb_1{width:190px}._blueBoxLogo_x4ebb_5{width:70px}}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'dontLiveWithoutLogo': '_dontLiveWithoutLogo_x4ebb_1', 'blueBoxLogo': '_blueBoxLogo_x4ebb_5', 'collapsibleTextBody': '_collapsibleTextBody_x4ebb_9' };
export const dontLiveWithoutLogo = '_dontLiveWithoutLogo_x4ebb_1';
export const blueBoxLogo = '_blueBoxLogo_x4ebb_5';
export const collapsibleTextBody = '_collapsibleTextBody_x4ebb_9';
export { css, digest };